import { render } from "./ProjectFilter.vue?vue&type=template&id=af135b70"
import script from "./ProjectFilter.vue?vue&type=script&lang=js"
export * from "./ProjectFilter.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__